<template>
    <Transition v-if="isLoading"
                name="spinner">
        <div id="cover-spin"></div>
    </Transition>

    <v-form :name="formProps.formName"
            @keyup.enter="autoSave = false">
        <TabView scrollable
                 style="overflow: visible"
                 :pt="{ panelContainer: { class: 'form-tab-panel' } }">
            <TabPanel :header="__('Basic data')"
                      headerClass="form-tab-header">
                <div class="grid">
                    <FormInputText fieldName="rate_name"
                                   label="Rate name"
                                   size="10"
                                   validation="required"
                                   :isFormDisabled="isFormDisabled"
                                   :isFocus="true"
                                   v-model:field="crud.rate_name" />

                    <FormInputNumber fieldName="year"
                                     label="Year"
                                     size="2"
                                     :useGrouping="false"
                                     :min="2024"
                                     :minFractionDigits="0"
                                     :maxFractionDigits="0"
                                     :isFormDisabled="isFormDisabled"
                                     v-model:field="crud.year" />
                </div>
                <div class="grid">
                    <FormEditor fieldName="description"
                                label="Description"
                                :editorStyle="{ height: '120px' }"
                                :isFormDisabled="isFormDisabled"
                                v-model:field="crud.description" />
                </div>
            </TabPanel>

            <TabPanel :header="__('Rates values')"
                      headerClass="form-tab-header">
                <FormRepeaterTable v-model:record="crud.rateValues"
                                   :keys="{ 'period': null, 'value': null, 'description': null }"
                                   :disabled="isFormDisabled"
                                   :isFirstRowEmpty="false"
                                   :isCopyButton="false"
                                   repeaterStyle="margin-top:5px;"
                                   name="rateValues"
                                   :title="[__('Assessment period'), __('Rate value'), __('Description')]">
                    <template #repeat="slotProps">
                        <td :style="slotProps.cellStyle"
                            style="width:10%;min-width:150px">
                            <FormDropdown fieldName="period"
                                          size="2"
                                          scrollHeight="200px"
                                          class="w-full"
                                          :inRepeater="true"
                                          :filtering="false"
                                          :isFormDisabled="isFormDisabled"
                                          :options="select?.quarter_periods"
                                          v-model:field="slotProps.record.period" />
                        </td>
                        <td :style="slotProps.cellStyle"
                            style="width:60%;min-width:300px">
                            <FormInputText fieldName="value"
                                           class="w-full"
                                           :isFormDisabled="isFormDisabled"
                                           :inRepeater="true"
                                           v-model:field="slotProps.record.value" />
                        </td>
                        <td :style="slotProps.cellStyle"
                            style="width:30%;min-width:250px">
                            <FormTextarea fieldName="description"
                                          rows="3"
                                          :inRepeater="true"
                                          :isFormDisabled="isFormDisabled"
                                          v-model:field="slotProps.record.description" />
                        </td>
                    </template>
                </FormRepeaterTable>
            </TabPanel>

            <TabPanel v-if="crud.log"
                      :header="__('Changelog')"
                      headerClass="form-tab-header">
                <ChangeLog :log="crud?.log" />
            </TabPanel>

        </TabView>

        <div class="grid">
            <FormButtons :formProps="props.formProps"
                         :sourceForm="crud"
                         :validation="validation"
                         :buttonsVisibility="buttonsVisibility"
                         v-model:isFormDisabled="isFormDisabled"
                         v-model:autoSave="autoSave">
            </FormButtons>
        </div>
    </v-form>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import { validation, initForm } from '@pages/Helper/crud_utils.js'
import FormInputText from '@crud/FormInputText.vue'
import FormInputNumber from '@crud/FormInputNumber.vue'
import FormDropdown from '@crud/FormDropdown.vue'
import FormEditor from '@crud/FormEditor.vue'
import FormTextarea from '@crud/FormTextarea.vue'
import FormButtons from '@crud/FormButtons.vue'
import FormRepeaterTable from '@crud/FormRepeaterTable.vue'
import ChangeLog from '@crud/ChangeLog.vue'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
})

const isLoading = ref(true);
const isFormDisabled = ref(false)
const autoSave = ref(false)

const options = ['quarter_periods']
const select = ref(null)
const crud = ref({})
const buttonsVisibility = ref(null);

// -----------------------------------------------------

onMounted(async () => {
    await initForm(props, crud, isLoading, options, select, buttonsVisibility)
})

// -----------------------------------------------------


</script>

<style lang="scss" scoped></style>
